import { Text } from "@/components/ui/text";
import { Avatar } from "@features/Avatar";
import { Show } from "solid-js";
import { Box, Flex, Grid } from "styled-system/jsx";
import { Rank } from "./Rank";

export default function (props: { username?: string | null, id?: string | null, label?: string, rank?: string, direction?: 'row' | 'row-reverse' }) {
  return (
    <Show when={props.username && props.id}>
      <Flex justifyContent='end' gap='1' alignItems='center' direction={props.direction ?? 'row'}>
        <Grid gap="0" justifyContent='end'>
          <Text color='fg.subtle' fontSize="8px" fontStyle='italic' textAlign='right' lineHeight={0.7}>
            {props.label}
          </Text>
          <Text textStyle="xs">
            {props.username}
          </Text>
        </Grid>
        <Box position='relative' flexShrink={0} w='30px' h='30px'>
          <Avatar id={props.id ?? undefined} />
          <Show when={props.rank}>
            <Box
              pos="absolute"
              bottom='-3px'
              right='-3px'
              borderRadius='full'
              bg='editorialPanel'
              boxShadow='0 0 0 1px var(--colors-editorial-hair-strong)'
            >
              <Rank rank={props.rank ?? undefined} dimensions='14px' />
            </Box>
          </Show>
        </Box>
      </Flex>
    </Show>
  )
}
